import hireny from "../assets/projects/HireNy.png";
import sales from "../assets/projects/SupermarketSalesDashboard.png"
import imdb from "../assets/projects/imdb.png"

const projects = [
    {
        title: "Supermarket Sales Analysis",
        description:
            "A comprehensive sales data analysis project for a supermarket chain using Excel's advanced features.",
        keyFeatures: [
            "Data cleaning and preparation using Power Query",
            "In-depth sales analysis with Pivot Tables and Charts",
            "Identified sales trends, best selling products, and customer demographics",
        ],
        techUsed: ["Excel", "Power Query", "Pivot Tables", "Pivot Charts", "Data Analysis"],
        notes: "",
        img: sales,
        link: "https://www.behance.net/gallery/237855229/Supermarket-Sales-Dashboard"
    },
    {
        title: "Graduation Project – HireNy",
        description:
        "A recruitment cross-platform Focused on intelligent job matching, CV generation, and applicant ranking.",
        keyFeatures: [
            "End-to-end development lifecycle: idea, research, system analysis (SRS, UML), UI/UX, implementation, and testing",
            "Job Recommendation Engine – personalized job suggestions using seeker profiles and qualifications",
            "Document AI Builder – automatic CV, resume, and cover letter generation",
            "Candidate Ranking System – ranked applicants using smart compatibility algorithms",
            "Automated assessments and in-app meeting features for seamless candidate evaluation and interview management.",
        ],
        techUsed: ["React", "Django", "Flutter", "Bootstrap", "JavaScript", "Python", "HTML5", "CSS3", "Figma"],
        notes: "GP",
        img: hireny,
        link: "https://drive.google.com/drive/folders/1bJfRRZPV6GqY3y_xmtGOoybUpC10im3n"
    },
    {
        title: "Best Movies ETL",
        description:
            "An ETL pipeline project for extracting, transforming, and loading IMDb movie data using Python and web scraping tools.",
        keyFeatures: [
            "Extracted data via web scraping",
            "Performed data cleaning and transformation",
            "Stored data in multiple formats (CSV, JSON, SQL)",
            "Added logging and error handling for reliability",
        ],
        techUsed: ["Web Scraping", "Python", "BeautifulSoup", "request", "Pandas", "ETL"],
        notes: "",
        img: imdb,
        link: "https://github.com/DoaaAli11/Best-Movies-ETL"
    },
    {
        title: "Chinook Data Warehouse",
        description:
            "A data warehouse solution for the Chinook OLTP database using SQL Server and SSIS, emphasizing analytical design and performance.",
        keyFeatures: [
            "Star schema architecture with fact and dimension tables",
            "ETL pipelines with automated scheduling via SSIS",
            "Defined KPIs and analytical query layer for insight generation",
            "Comprehensive system design and data architecture",
        ],
        techUsed: ["SQL Server", "SSIS", "ETL", "Data Warehouse"],
        notes: "TB",
    },
    {
        title: "Toffee Project",
        description:
            "A console-based Java system developed through structured analysis and design, emphasizing requirements-driven development.",
        keyFeatures: [
            "Requirements specification and SRS documentation",
            "UML design including use case, workflow, and system models",
            "User registration, login, and OTP verification modules",
            "Structured lifecycle from analysis to testing",
        ],
        techUsed: ["Java", "SRS", "System Analysis", "OOP"],
        notes: "TB",
        link: "https://github.com/DoaaAli11/Toffee-Store-Software"
    },
    {
        title: "Student Affairs System",
        description:
            "A Django-based full-stack web system for managing student data with CRUD functionality and dynamic UI interaction.",
        keyFeatures: [
            "Student record management and CRUD operations",
            "Dynamic frontend interaction using AJAX and session storage",
            "Frontend–backend integration through Django framework",
            "Full-stack architecture and clean interface design",
        ],
        techUsed: ["Python", "Django", "HTML5", "CSS3", "JavaScript", "AJAX"],
        notes: "TB",
        link: "https://github.com/youssefahmedzakaria/student_affairs_website"
    },
];

export const getProjectData = () => {
    return projects;
};
